/*
 * Brancaia — Sticky-Add-to-Cart-Leiste (nur Mobile).
 *
 * - Spiegelt die aktuell gewählte Variante; schaltet clientseitig aus dem
 *   vorgerenderten JSON um (kein Netzwerk-Request beim Variantenwechsel).
 * - Klickt den ECHTEN Kaufbutton (kein zweites Formular).
 * - IntersectionObserver statt Scroll-Listener.
 * - Nur Mobile (matchMedia), sauberer Teardown auf Desktop.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var data;
  try {
    data = JSON.parse(bar.querySelector('[data-sticky-atc-json]').textContent);
  } catch (e) {
    if (window.console && console.warn) console.warn('[sticky-atc] Varianten-JSON ungültig, Leiste deaktiviert:', e);
    return;
  }
  var variants = data.variants || {};
  var labels = data.labels || {};

  var els = {};
  function refs() {
    els.stock = bar.querySelector('[data-sticky-stock]');
    els.stockText = bar.querySelector('[data-sticky-stock-text]');
    els.size = bar.querySelector('[data-sticky-size]');
    els.thumb = bar.querySelector('[data-sticky-thumb]');
    els.priceCurrent = bar.querySelector('[data-sticky-price-current]');
    els.priceWas = bar.querySelector('[data-sticky-price-was]');
    els.cta = bar.querySelector('[data-sticky-cta]');
    els.ctaText = bar.querySelector('[data-sticky-cta-text]');
    els.ctaSub = bar.querySelector('[data-sticky-cta-sub]');
  }
  refs();

  var mq = window.matchMedia('(max-width: 749px)');
  var buyObserver = null;
  var footerObserver = null;
  var buyAbove = false;
  var footerVisible = false;
  var initialized = false;
  var addedTimer = null;

  function esc(s) { return s == null ? '' : String(s); }
  // Nur Zeile 1 des Buttons beschreiben; die Pickup-Zeile bleibt stehen.
  function setCtaText(t) { (els.ctaText || els.cta).textContent = esc(t); }

  // ── Produktformular + echter Kaufbutton ──
  function form() { return document.querySelector('form[data-type="add-to-cart-form"]'); }

  function realButton() {
    var f = form();
    if (f) {
      var b = f.querySelector('.add-to-cart') || f.querySelector('button[name="add"]');
      if (b) return b;
    }
    return document.querySelector('form[data-type="add-to-cart-form"] .add-to-cart, form[data-type="add-to-cart-form"] button[name="add"]');
  }

  function currentId() {
    var f = form();
    var idInput = f ? f.querySelector('[name="id"]') : null;
    if (idInput && idInput.value) return String(idInput.value);
    return String(bar.getAttribute('data-current-id') || '');
  }

  // ── Leiste an die aktuelle Variante angleichen ──
  function update() {
    var v = variants[currentId()];
    if (!v) return;

    if (els.size) els.size.textContent = esc(v.size);

    if (els.stock) {
      if (v.available) {
        els.stock.hidden = false;
        if (els.stockText) els.stockText.textContent = esc(labels.inStock);
      } else {
        els.stock.hidden = true;
      }
    }

    if (els.thumb && v.image) els.thumb.src = v.image;

    if (els.priceCurrent) {
      els.priceCurrent.textContent = esc(v.price);
      els.priceCurrent.classList.toggle('is-sale', !!v.compare);
    }
    if (els.priceWas) {
      if (v.compare) {
        els.priceWas.hidden = false;
        els.priceWas.textContent = esc(v.compare);
      } else {
        els.priceWas.hidden = true;
      }
    }

    if (els.cta && !addedTimer) {
      if (v.available) {
        els.cta.disabled = false;
        setCtaText(labels.cta);
        els.cta.setAttribute('aria-label', esc(labels.cta) + ' – ' + esc(v.size) + ', ' + esc(v.price));
      } else {
        els.cta.disabled = true;
        setCtaText(labels.soldOut);
        els.cta.setAttribute('aria-label', esc(labels.soldOut) + ' – ' + esc(v.size));
      }
      if (els.ctaSub) els.ctaSub.hidden = !(v.available && v.pickupOnly);
    }
  }

  // ── Sichtbarkeit ──
  function setVisible(vis) {
    if (vis) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }
  function recompute() { setVisible(buyAbove && !footerVisible); }

  // ── Klick: echten Button klicken + Analytics ──
  function onCta() {
    var id = currentId();
    var v = variants[id];
    if (!v || !v.available) return; // ausverkauft: wirkungslos

    try {
      document.dispatchEvent(new CustomEvent('sticky-atc:add', {
        detail: { variantId: id, price: v.price, source: 'sticky' }
      }));
    } catch (e) { /* noop */ }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'sticky-atc:add', variantId: id, price: v.price, source: 'sticky' });
    }

    var btn = realButton();
    if (btn) {
      btn.click();
    } else {
      var f = form();
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    }

    if (els.cta) {
      setCtaText(labels.added);
      if (addedTimer) clearTimeout(addedTimer);
      addedTimer = setTimeout(function () { addedTimer = null; update(); }, 1400);
    }
  }

  // ── Variantenwechsel: delegiert am document (Bubble, damit die Theme-ID
  //    bereits aktualisiert ist) + Theme-Event ──
  function onChange(e) {
    var f = form();
    if (f && e.target && f.contains(e.target)) update();
  }
  function onThemeVariant() { update(); }
  function themeEventName() {
    var picker = document.querySelector('[data-section-id][data-product-id]');
    if (!picker) return null;
    return 'variant:change:' + picker.getAttribute('data-section-id') + ':' + picker.getAttribute('data-product-id');
  }
  var boundThemeName = null;

  // ── Init / Teardown ──
  function init() {
    if (initialized) return;
    initialized = true;

    bar.hidden = false;
    document.body.appendChild(bar); // an <body>, damit kein transformierter Vorfahre die Fixierung bricht
    refs();
    update();

    var buyEl = form() || document.querySelector('[data-sticky-buy-area]');
    var footerEl = document.querySelector('.site-footer, footer, [data-section-type="footer"]');

    if (buyEl && 'IntersectionObserver' in window) {
      buyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          buyAbove = !en.isIntersecting && en.boundingClientRect.bottom <= 0;
          recompute();
        });
      }, { threshold: 0 });
      buyObserver.observe(buyEl);
    }
    if (footerEl && 'IntersectionObserver' in window) {
      footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { footerVisible = en.isIntersecting; recompute(); });
      }, { threshold: 0 });
      footerObserver.observe(footerEl);
    }

    document.addEventListener('change', onChange, false);
    boundThemeName = themeEventName();
    if (boundThemeName) document.addEventListener(boundThemeName, onThemeVariant);
    if (els.cta) els.cta.addEventListener('click', onCta);
  }

  function teardown() {
    if (!initialized) return;
    initialized = false;

    setVisible(false);
    bar.hidden = true;
    buyAbove = false;
    footerVisible = false;

    if (buyObserver) { buyObserver.disconnect(); buyObserver = null; }
    if (footerObserver) { footerObserver.disconnect(); footerObserver = null; }
    document.removeEventListener('change', onChange, false);
    if (boundThemeName) { document.removeEventListener(boundThemeName, onThemeVariant); boundThemeName = null; }
    if (els.cta) els.cta.removeEventListener('click', onCta);
  }

  function apply() { if (mq.matches) init(); else teardown(); }
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
